import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col, Typography, Affix, Button, Icon } from 'antd';

import './documentsCard.css';

// Components
import DocumentTable from '../components/DocumentTable/DocumentTable';
import OrderInfo from '../components/Sidebar/OrderInfo';
import OrderStatus from '../components/Sidebar/OrderStatus';
import TopPanel from '../components/TopPanel/TopPanel';
// Футтер !
import Footer from '../../../../common/hoc/withFooter';
import DocsCardFooter from '../components/Footer/Footer';

// Redux Actions
import { interfaceActions } from '../../../../common/redux/actions';
import { documentCardActions } from '../redux/actions';
import * as URLs from '../../../../common/constants/systemUrls';
import moment from 'moment';
import { getNumberWithoutSpaces } from '../../../../common/utils/format';

let { setCaption } = interfaceActions;
let { getOrderForDocumentsById } = documentCardActions;

const { Text } = Typography;

let editIcn = <Icon type="edit" />;
let printIcn = <Icon type="printer" />;
let downloadIcn = <Icon type="download" />;

class DocumentsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: this.getOrderId(),
      drawerCols: {
        info: true,
        status: true,
        dateApplication: true,
        carrier: true,
        actions: true,
      },
      tableColumnsLen: 0,
      selectedRows: [],
      pagination: {
        pages: 3,
      },
      filter: {
        status: false,
      },
    };
    this.state.tableColumnsLen = this.getTableColumnsLen();
  }

  componentDidMount() {
    this.setCaption(true);
    if (this.state.orderId > 0) {
      this.props.getOrderForDocumentsById(this.state.orderId);
    }
  }
  componentDidUpdate(prevProps) {
    this.setCaption(this.props.order !== prevProps.order && this.props.order);
  }
  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = '';
      const { order } = this.props;
      if (order && this.state.orderId === order.orderId) {
        title =
          (order.orderName ? `${order.orderName} - ` : '') +
          getNumberWithoutSpaces(order.orderNumber);
      }
      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            // Путь для хлебных крошек
            {
              path: '/' + URLs.CONTROL_PANEL,
              breadcrumbName: 'Панель управления',
            },
            {
              path: '/' + URLs.DOCUMENT_BY_ORDERS,
              breadcrumbName: 'Документы',
            },
            { path: '/' + URLs.DOCUMENT_BY_ORDERS, breadcrumbName: title },
          ],
        });
      }
    }
  }

  getTableColumnsLen = (drawerCols = null) => {
    return Object.values(
      drawerCols ? drawerCols : this.state.drawerCols
    ).reduce((count, val) => (val === true ? ++count : count), 0);
  };

  getOrderId() {
    let { id = 0 } = this.props.match && this.props.match.params;
    id = Number(id);
    return id > 0 ? id : 0;
  }

  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e),
      },
    }));
  };

  onChangeRowSelection = row => {
    this.setState(state => ({
      ...state,
      selectedRows: row,
    }));
    console.log(row);
  };

  handleClickRow = row => {
    return {
      onClick: () => {
        console.log(row);
      },
    };
  };

  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];

    let href = '#';

    let cols = [
      {
        title: 'Название документа',
        dataIndex: 'info',
        key: 'info',
        render: info => (
          <span>
            <Text>{info.type}</Text>
          </span>
        ),
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        key: 'status',
        render: status => (
          <span>
            <Text>{status.status}</Text>
          </span>
        ),
      },
      {
        title: 'Дата изменения',
        dataIndex: 'dateApplication',
        key: 'dateApplication',
        render: dateApplication =>
          dateApplication ? (
            <span>
              {moment(dateApplication).format('DD.MM.YYYY HH:mm')}
              <br />
              <Text type="secondary">{moment(dateApplication).fromNow()}</Text>
            </span>
          ) : null,
      },
      {
        title: 'Ответственный',
        dataIndex: 'carrier',
        key: 'carrier',
        render: carrier => (
          <span>
            <Text>Не указан</Text>
          </span>
        ),
      },
      {
        title: '',
        key: 'actions',
        dataIndex: 'actions',
        render: actions => (
          <span className="actions">
            {actions.map(action => {
              switch (action) {
                case 'edit':
                  return (
                    <a href={href} key={action} className="icon">
                      {editIcn}
                    </a>
                  );
                case 'print':
                  return (
                    <a href={href} key={action} className="icon">
                      {printIcn}
                    </a>
                  );
                case 'download':
                  return (
                    <a href={href} key={action} className="icon">
                      {downloadIcn}
                    </a>
                  );
                default:
                  return null;
              }
            })}
          </span>
        ),
      },
    ];
    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    return filteredCols;
  };

  onChangeTypeList = e => {
    let statusOrder = e.target.value;
    if (statusOrder === 'all') {
      statusOrder = false;
    }
    this.setState(state => ({
      filter: {
        ...state.filter,
        status: statusOrder,
      },
    }));
    // todo markers: this.filterMarkers(offersList),
  };

  getDocuments() {
    const { documents } = this.props;
    const { filter } = this.state;
    if (!documents || this.state.orderId !== this.props.order.orderId)
      return [];
    if (filter.status) {
      return documents.filter(
        item => item.status && item.status.statusKeyGroup === filter.status
      );
    }
    return documents;
  }

  render() {
    const documentData = this.getDocuments();
    return (
      <div id="docsCard" className="site-wrapper">
        <Row className="offer-create__form-wrap" style={{ display: 'flex' }}>
          <Col span={18}>
            <div className="documents__top-panel">
              <TopPanel
                typesList={this.props.documentTypes}
                stat={this.props.documentsStat}
                totalOffers={
                  this.props.documents ? this.props.documents.length : 0
                }
                onChangeTypeList={this.onChangeTypeList}
              />
            </div>
            <div className="document-content">
              <DocumentTable
                renderColumns={this.renderColumns}
                tableColumnsLen={this.state.tableColumnsLen}
                document={documentData}
                // pages={pagination.pages}
                documentLoading={this.props.documentLoading}
                // changePaginationSize={this.changePaginationSize}
                onChangeTable={this.onChangeTable}
                handleClickRow={this.handleClickRow}
                onChangeRowSelection={this.onChangeRowSelection}
              />
            </div>
          </Col>
          <Col span={6} className="document-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById('mainSheet')}
            >
              <React.Fragment>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className="offers-create__submit"
                  onClick={() => {
                    this.props.history.push(
                      `/executorship/order/${this.state.orderId}`
                    );
                  }}
                >
                  Перейти к заказу
                </Button>
                <Button
                  style={{ background: '#ffffff' }}
                  ghost
                  type="primary"
                  htmlType="submit"
                  size="large"
                  disabled
                  className="offers-create__submit"
                >
                  Отчет по заказу
                </Button>
                <div className="document-card__block">
                  <OrderInfo {...this.props} />
                </div>
                <div className="document-card__block">
                  <OrderStatus {...this.props} />
                </div>
                <Button
                  style={{ background: '#ffffff' }}
                  ghost
                  type="primary"
                  htmlType="submit"
                  size="large"
                  disabled
                  className="offers-create__submit"
                >
                  Отправить в АЦБПДП
                </Button>
                <Button
                  style={{ background: '#ffffff' }}
                  ghost
                  type="primary"
                  htmlType="submit"
                  size="large"
                  disabled
                  className="offers-create__submit"
                >
                  Отправить в ГИБДД
                </Button>
              </React.Fragment>
            </Affix>
          </Col>
        </Row>
        <Footer>
          <DocsCardFooter disabled={this.state.selectedRows} />
        </Footer>
      </div>
    );
  }
}

export default connect(
  state => {
    const { documentCard } = state.Documents.docCard;
    return {
      documentLoading: documentCard.isLoading,
      order: documentCard.data,
      documents: documentCard.data && documentCard.data.documents,
      documentTypes: documentCard.documentTypes,
      documentsStat: documentCard.documentsStat,
    };
  },
  {
    setCaption,
    getOrderForDocumentsById,
  }
)(DocumentsCard);
